import actions from "./actions";

const initialState = {
  loading: false,
  error: false,
  signUpAggrement: null,
  isModalOpen: false,
  postOtpResponse: null,
  acceptSuccess: null,
  errorMessage: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.REGISTER_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actions.REGISTER_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case actions.REGISTER_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actions.LOGIN_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actions.LOGIN_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case actions.LOGIN_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actions.POST_OTP_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        postOtpResponse: null,
      };
    case actions.POST_OTP_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        postOtpResponse: action.payload.data,
      };
    case actions.POST_OTP_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload.data,
        postOtpResponse: null,
      };
    case actions.GET_AGGREMENT_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        signUpAggrement: null,
      };
    case actions.GET_AGGREMENT_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        signUpAggrement: action.payload.data,
      };
    case actions.GET_AGGREMENT_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        signUpAggrement: null,
      };
    case actions.ACCEPT_AGGREMENT_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        acceptSuccess: null,
      };
    case actions.ACCEPT_AGGREMENT_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        acceptSuccess: true,
      };
    case actions.ACCEPT_AGGREMENT_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        acceptSuccess: null,
      };
    case actions.CREATE_OTP_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actions.CREATE_OTP_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        isModalOpen: true,
      };
    case actions.CREATE_OTP_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        isModalOpen: false,
        errorMessage: action.payload.data,
      };
    case actions.CLOSE_MODAL:
      return {
        ...state,
        isModalOpen: false,
      };
    case actions.RESET_AGREEMENT:
      return {
        ...state,
        acceptSuccess: null,
      };
    case actions.RESET_OTP_RESPONSE:
      return {
        ...state,
        postOtpResponse: null,
        isModalOpen: false,
      };
    case actions.RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    case actions.GET_USER_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedUser: action.payload.data,
      };
    case actions.GET_USER_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;